import con from '../../../../connection';
var path = '/members';
var members = function (url) { return function () { return ({
    post: function (param, options) { return con.post(url + path, param, options === null || options === void 0 ? void 0 : options.noError, options === null || options === void 0 ? void 0 : options.timeoutMS); },
}); }; };
export default members;
